var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-item"},[(_vm.useTag)?_c('el-tag',_vm._b({},'el-tag',_vm.$attrs,false),[_vm._v(_vm._s(_vm.content))]):_c('span',[_vm._v(_vm._s(_vm.content))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }